import React from 'react'
import PropTypes from 'prop-types';
import classNames from 'classnames';

function ContentDivider(props) {
    const {
        type,
        children,
        className,
        ...others
    } = props;

    return (
        <div className={classNames("pgn__contentdivider-wrapper", className)}>
            {type === 'line' &&
                <div className="contentdivider-line"></div>
            }

            {type === 'line-spacing' &&
                <div className="contentdivider-line-spacing"></div>
            }

            {type === 'text-and-line-divider' &&
                <div className="contentdivider-text-and-line-divider">
                    <div className="contentdivider-text-and-line-divider-left"></div>
                    <span className="contentdivider-text-and-line-divider-label">{children}</span>
                    <div className="contentdivider-text-and-line-divider-right"></div>
                </div>
            }

            {type === 'text-divider' &&
                <div className="contentdivider-text-divider">
                    <span className="contentdivider-text-divider-label">{children}</span>
                </div>
            }

            {type === 'solid-text-divider' &&
                <div className="contentdivider-solid-text-divider">
                    <span className="contentdivider-solid-text-divider">{children}</span>
                </div>
            }

            {type === 'component' &&
                <div className="contentdivider-component">
                    <div className="contentdivider-component-left"></div>
                    <div className="contentdivider-component-div">{children}</div>
                    <div className="contentdivider-component-right"></div>
                </div>
            }
        </div>
    )
}

const types = [
    'line',
    'line-spacing',
    'text-and-line-divider',
    'text-divider',
    'solid-text-divider',
    'component'
];

ContentDivider.propTypes = {
    type: PropTypes.oneOf(types).isRequired,
    children: PropTypes.node,
    className: PropTypes.string
}

ContentDivider.defaultProps = {
    type: 'line',
    children: null,
    className: ''
}

export default ContentDivider